/* Produkt na zamowienie — przelaczanie przy zmianie wariantu.
 *
 * Termin realizacji jest cecha wariantu (rozne kolory moga miec rozne terminy),
 * a warianty przelaczaja sie bez przeladowania strony. Serwer renderuje stan
 * dla wariantu poczatkowego, ten skrypt utrzymuje go dalej.
 *
 * Regula "czy na zamowienie" i skladanie tlumaczen zostaja po stronie Liquida:
 * made-to-order-notice.liquid liczy termin i aktywnosc dla KAZDEGO wariantu
 * i zapisuje je w [data-mto-variants]. Tutaj tylko odczyt tabeli i podmiana
 * tekstu — zadnego duplikowania warunkow ani zadnej logiki jezykowej.
 *
 * Podzial wzgledem pdp-shipping.js: tamten skrypt przelacza elementy WEWNATRZ
 * wiersza dostawy, ten chowa caly wiersz. Rozne wezly, wiec sie nie sciagaja.
 */
(function () {
  var notice = document.querySelector('[data-mto-notice]');

  // Brak wiersza => produkt nie jest na zamowienie albo nie ma kompletu dni.
  if (!notice) return;

  var dataEl = notice.querySelector('[data-mto-variants]');
  if (!dataEl) return;

  var variants;
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var deliveryRow = document.querySelector('[data-shipping-delivery-row]');
  var rangeEl = notice.querySelector('[data-mto-range]');
  var detailsEl = notice.querySelector('[data-mto-details]');
  var exceptionEl = notice.querySelector('[data-mto-exception]');
  var property = notice.querySelector('[data-mto-property]');

  // Nota urlopowa mowi o normalnym rytmie wysylki ("zamow do 14:00 — wyslemy
  // tego samego dnia", "wyslemy 9 wrzesnia"). Dla wariantu na zamowienie jest
  // nieprawdziwa, wiec chodzi dokladnie odwrotnie do wiersza MTO. Gdy produkt
  // ma ten wiersz, to my jestesmy wlascicielem noty — pdp-shipping.js jej wtedy
  // nie rusza, zeby nie przelaczac jej z dwoch miejsc naraz.
  var vacationNote = document.querySelector('[data-vacation-pdp]');
  var shippingBlock = document.querySelector('.pdp-shipping[data-cutoff]');

  function apply(state) {
    var active = !!(state && state.active);

    notice.style.display = active ? '' : 'none';
    if (vacationNote) vacationNote.style.display = active ? 'none' : '';

    if (deliveryRow) {
      // W fazie 'delay' trybu urlopowego wiersz dostawy nie moze wrocic nawet
      // dla wariantu ze stanu: niesie obietnice daty ("Wysylka juz jutro"),
      // ktorej w urlopie nie dotrzymamy, a pdp-shipping.js swiadomie go wtedy
      // nie przelicza, wiec zostalby z nieaktualnym tekstem serwera.
      var vacationDelay = shippingBlock && shippingBlock.dataset.vacationDelay === 'true';
      deliveryRow.style.display = active || vacationDelay ? 'none' : '';
    }

    if (active) {
      if (rangeEl) rangeEl.textContent = state.range;

      if (exceptionEl) exceptionEl.textContent = state.exception || '';
      if (detailsEl) {
        detailsEl.style.display = state.exception ? '' : 'none';
        // Rozwijamy przy zmianie wariantu. Tresc wyjatku jest juz podmieniona
        // na aktualna (wyzej), a informacja o mozliwym wydluzeniu terminu musi
        // byc widoczna bez klikania — tak samo dla wariantu wybranego recznie,
        // jak dla tego wyrenderowanego przez serwer.
        detailsEl.open = true;
      }
    }

    // Ukryta kontrolka nadal trafia do FormData — o wykluczeniu decyduje
    // disabled, inaczej wariant kupiony ze stanu dostalby termin na zamowienie.
    if (property) {
      property.disabled = !active;
      if (active) property.value = state.range;
    }
  }

  document.addEventListener('change', function (e) {
    if (!e.target.closest('.js-variant-selector, [name="id"]')) return;

    var vidEl = document.querySelector('.formVariantId[name="id"]');
    if (!vidEl) return;

    apply(variants[String(parseInt(vidEl.value, 10))]);
  });
})();
